import { useState } from "react";
import colors from "../../config/colors";
import { isString } from "../../Utilities/utils";
import { FaCheck, FaCloudDownloadAlt } from "react-icons/fa";

const defaultHeaders = [
  "firstName",
  "lastName",
  "middleName",
  "gender",
  "entryClassId",
  "stateOfResidence",
  "lgaOfResidence",
  "stateOfOrigin",
  "lgaOfOrigin",
  "religion",
  "nationality",
  "previousSchool",
];

export default function DownloadCSV({
    bottom = "8%",
    width = 35,
    height = 35,
    borderRadius = 35,
    right = 15,
    actionTitle = 'Copy',
    copyTooltipTop = -40,
    headers = defaultHeaders,
    classId,
    classTitle,
    transform = "translateX(-70%)",
}) {
  const [showTooltip, setShowTooltip] = useState(false);
  const [toolTipMsg, setToolTipMsg] = useState(actionTitle);
  const [downloaded, setDownloaded] = useState(false);

    const downloadCSV = () => {

        // Create an empty row
        const row = headers.map((header) =>
            header === "entryClassId" && isString(classId) ? classId : ""
        );

        const csvContent = [
            headers.join(","),
            row.join(","),
        ].join("\n");

        const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;",
        });

        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = isString(classTitle) ?`${classTitle} students.csv` : "students.csv";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);


        setDownloaded(true);
        setToolTipMsg("Download Successful.");
        setShowTooltip(true);

        // Change back to copy icon after 2 seconds
        setTimeout(() => {
            setDownloaded(false);
            setToolTipMsg("Download CSV Template.");
            setShowTooltip(false);
        }, 2000);
    };

  return (
    <div className="floating-button-wrapper" style={{ bottom, right }}>
      {
        showTooltip && (
            <div className="copy-tooltip-box" style={{ top: copyTooltipTop, transform }}>
                <div className="copy-tooltip">
                    { toolTipMsg && <span>{toolTipMsg}</span> }
                </div>
            </div>
        )
      }
      <div
        className="floating-button-box"
        style={{
          width,
          height,
          borderRadius,
            backgroundColor: downloaded ? colors.success : colors.primary,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          bottom,
          right,
          cursor: "pointer",
          opacity: downloaded ? 0.6 : 1,
          transform: "0.2s",
        }}
        onMouseEnter={() => {
            if (!downloaded) setShowTooltip(true);
        }}
        onMouseLeave={() => {
            if (!downloaded) setShowTooltip(false);
        }}
        onClick={() => downloadCSV()}
      >
        {
            downloaded ? <FaCheck color={colors.white} /> : <FaCloudDownloadAlt color={colors.white} />
        }
      </div>
    </div>
  );
}